/** Gidisat hero'ya ozel bicimleyiciler — legacy `ozet.js` fmtX/fmtPct100/fmtGun/fmtPuan portu. */

export function fmtX(v: number | null | undefined): string {
  if (v == null || Number.isNaN(v)) return "—";
  return v.toLocaleString("tr-TR", { maximumFractionDigits: 2 }) + "x";
}

/** `_oran(..., 100)` gibi ZATEN yuzde birimine cevrilmis alanlar (fmtPct'in aksine tekrar *100 yapmaz). */
export function fmtPctAlready(v: number | null | undefined): string {
  if (v == null || Number.isNaN(v)) return "—";
  return "%" + Math.abs(v).toLocaleString("tr-TR", { maximumFractionDigits: 1 });
}

export function fmtGun(v: number | null | undefined): string {
  if (v == null || Number.isNaN(v)) return "—";
  return v.toLocaleString("tr-TR", { maximumFractionDigits: 1 }) + " gün";
}

export function fmtPuan(v: number | null | undefined): string {
  if (v == null || Number.isNaN(v)) return "—";
  return v.toLocaleString("tr-TR", { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + " ★";
}

export type VerdictLevel = "good" | "warn" | "bad";

/**
 * hukum.cls ('pozitif'|'negatif'|'karisik'|'notr') → VerdictBox seviyesi.
 * VerdictBox yalniz good/warn/bad tasir (iskelet bileşen imzasi degistirilemez)
 * — notr'un rengi tarafsiz olmasi gereken amber/warn'a duser (en az yanlis
 * yonlendiren secim: ne "iyi" ne "kotu" damgasi vurur).
 */
export function hukumToVerdictLevel(cls: string | undefined): VerdictLevel {
  if (cls === "pozitif") return "good";
  if (cls === "negatif") return "bad";
  return "warn"; // karisik | notr
}
